<script>
export default {
    name: 'ChartingStockWorkspaceMembership',
    props: {
        stock: { type: Object, default: null },
        favoriteFolders: { type: Array, default: () => [] },
        canUseFavorites: { type: Boolean, default: false },
        isLoading: { type: Boolean, default: false },
        loadError: { type: [Object, String], default: null },
        isMutating: { type: Boolean, default: false },
        error: { type: String, default: '' }
    },
    methods: {
        isSelected(folder) { return Boolean(this.stock?.folderNames?.includes(folder.name)); },
        toggleFolder(folder, event) {
            // Reflect confirmed membership, including when the API rejects a change.
            event.target.checked = this.isSelected(folder);
            if (this.isMutating || !this.canUseFavorites || !this.stock?.ticker) return;
            this.$emit('toggle-folder', folder.name);
        }
    }
};
</script>

<template>
    <div class="charting-stock-membership">
        <p v-if="!canUseFavorites" class="charting-stock-membership__message">Tu plan actual no permite guardar valores en workspaces.</p>
        <p v-else-if="!stock || !stock.ticker" class="charting-stock-membership__message">Selecciona un valor para guardarlo.</p>
        <p v-else-if="isLoading && !favoriteFolders.length" class="charting-stock-membership__message" role="status">Cargando workspaces…</p>
        <div v-else-if="loadError" class="charting-stock-membership__message" role="alert">
            No se pudieron cargar tus workspaces.
            <button type="button" class="charting-stock-membership__retry" @click="$emit('retry')">Reintentar</button>
        </div>
        <p v-else-if="!favoriteFolders.length" class="charting-stock-membership__message">Todavía no tienes carpetas. Puedes crearlas desde Workspaces.</p>
        <div v-else class="charting-stock-membership__folders" :aria-busy="String(isMutating)">
            <label v-for="folder in favoriteFolders" :key="folder.id" class="charting-stock-membership__row" :class="{ 'is-disabled': isMutating }">
                <input
                    type="checkbox"
                    :checked="isSelected(folder)"
                    :disabled="isMutating"
                    :aria-label="stock.ticker + ' en ' + folder.label"
                    @change="toggleFolder(folder, $event)"
                />
                <span class="charting-stock-membership__color" :style="{ backgroundColor: folder.color }" aria-hidden="true"></span>
                <span>{{ folder.label }}</span>
            </label>
        </div>
        <p v-if="isMutating" class="charting-stock-membership__message" role="status">Guardando…</p>
        <p v-if="error" class="charting-stock-membership__error" role="alert">{{ error }}</p>
    </div>
</template>

<style scoped>
.charting-stock-membership { min-width: 0; }
.charting-stock-membership__message { margin: 0.55rem 0; color: var(--p-text-muted-color); font-size: 0.82rem; line-height: 1.5; }
.charting-stock-membership__row { display: flex; align-items: center; gap: 0.65rem; min-height: 2.75rem; padding: 0.55rem 0.5rem; border-radius: 0.55rem; color: var(--p-text-color); font-size: 0.85rem; cursor: pointer; overflow-wrap: anywhere; }
.charting-stock-membership__row:hover { background: var(--charting-b-hover-bg); }
.charting-stock-membership__row input { flex-shrink: 0; width: 1rem; height: 1rem; margin: 0; accent-color: var(--brand-primary); cursor: inherit; }
.charting-stock-membership__row input:focus-visible { outline: 2px solid var(--brand-primary); outline-offset: 3px; }
.charting-stock-membership__row.is-disabled { opacity: 0.6; cursor: wait; }
.charting-stock-membership__color { flex-shrink: 0; width: 0.55rem; height: 0.55rem; border-radius: 50%; box-shadow: inset 0 0 0 1px rgba(128, 128, 128, 0.25); }
.charting-stock-membership__error { margin: 0.65rem 0 0; border-left: 3px solid var(--p-red-500, #ef4444); padding-left: 0.6rem; font-size: 0.82rem; }
.charting-stock-membership__retry { display: block; margin-top: 0.5rem; border: 0; background: transparent; color: var(--brand-primary); font: inherit; cursor: pointer; }
</style>
